export const NumberPattern = (e) => {
    const pattern = /^\d{1,10}$/;
    if( pattern.test(e.target.value) ) e.target.value = e.target.value
    else e.target.value = e.target.value.slice(0, -1)
}


export const OTPPattern = (e) => {
    const pattern = /^\d{1,6}$/;
    if( pattern.test(e.target.value) ) e.target.value = e.target.value
    else e.target.value = e.target.value.slice(0, -1)
}

export const dateFormat = ( date ) => {
    const newDate = new Date(date)
    return newDate.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
}




export const convertTo12HourFormat = (time24) => {
    let [hours, minutes] = time24.split(':').map(Number);
    const period = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12 || 12;
    return `${hours}:${String(minutes).padStart(2, '0')} ${period}`;
}

export const ObjectToParams = (obj) => {
    return new URLSearchParams(obj).toString()
}